import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Form as FormBS } from "react-bootstrap";
import Select from "../../../../../../../../components/CustomSelect/Select";
import ReactTooltip from 'react-tooltip';
import { toast } from "react-toastify";

import { Formik, Form } from "formik";
import * as yup from 'yup';
import moment from 'moment';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import { editGuest, addGuests } from '../../../../../../../../general_redux/guest/actions';
import { editBookingContacts } from '../../../../../../../../general_redux/calendar/actions';
import ContactForm from './components/ContactForm';
import styles from './components/ContactForm.module.css';


const GuestDetails = (props) => {

    const dispatch = useDispatch();

    const user = useSelector(({ generalSetting }) => generalSetting && generalSetting.setting);
    const guestList = useSelector(({ guests }) => guests && guests.guestList);
    const bookingData = useSelector(({ calendar }) => calendar && calendar.allBooking.find((booking) => booking.id === calendar.bookingById.id))

    const [guestId, setGuestId] = useState(null);
    const [bookerId, setBookerId] = useState(null);
    const [changeGuest, setChangeGuest] = useState(true);
    const [changeBooker, setChangeBooker] = useState(true);

    const compare = (a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0);
    const phoneRegExp = /^[0-9-+\s()]*$/;
    const guestDetails = guestList.find(guest => guest.id === bookingData?.guestId);
    const bookerDetails = guestList.find(guest => guest.id === bookingData?.bookerId);

    const showWarningAboutContacts = () => toast.warn("The booker and the guest you selected are the same person.");

    const getContactInitialValues = (data) => {
        return {
            id: data?.id || null,
            name: data?.name || "",
            emailId: data?.emailId || "",
            secondaryEmailId: data?.secondaryEmailId || "",
            phoneNo: data?.phoneNo || "",
            secondaryPhoneNo: data?.secondaryPhoneNo || "",
            postalCode: data?.postalCode || "",
            country: data?.country || user.country,
            address: data?.address || "",
            street: data?.street || "",
            state: data?.state || "",
            nationality: data?.nationality || "",
            language: data?.language || "",
            company: data?.company || "",
            companyAddress: data?.companyAddress || "",
            notes: data?.notes || "",
            dob: data?.dob && !["Invalid da", "", null, "[NULL]"].includes(data.dob) ? new Date(moment(data.dob)) : null,
        };
    };

    const guestInitialValues = getContactInitialValues(guestDetails);
    const bookerInitialValues = getContactInitialValues(bookerDetails);

    const initialValues = {

        // Guest - initialValues
        guest: {
            ...guestInitialValues,
            selectedContact: true,
            selectedContactData: {
                label: guestInitialValues.name,
                value: guestInitialValues.id,
            },
        },
        
        // Booker - initialValues
        booker: {
            ...bookerInitialValues,
            selectedContact: true,
            selectedContactData: {
                label: bookerInitialValues?.name,
                value: bookerInitialValues?.id,
            },
            checkboxGuestMadeReservation: (guestDetails?.id === bookerDetails?.id),
        },

    };

    const contactValidationSchema = {
        name: yup.string().max(150, 'Must be 150 characters or less')
            .test(
                'is-required',
                'Name is a required field', function (value) {
                    if (this.parent.checkboxGuestMadeReservation) {
                        return true;
                    };
                    return value !== undefined && value !== null && value.trim() !== "";
                }),
        company: yup.string().max(150, 'Must be 150 characters or less'),
        companyAddress: yup.string().max(150, 'Must be 150 characters or less'),
        emailId: yup.string().max(150, 'Must be 150 characters or less').email('Invalid email'),
        secondaryEmailId: yup.string().max(150, 'Must be 150 characters or less').email('Invalid email'),
        phoneNo: yup.string().max(50, 'Must be 50 characters or less').matches(phoneRegExp, 'Only numbers, space, parenthesis, + and - are accepted.').nullable(),
        secondaryPhoneNo: yup.string().max(50, 'Must be 50 characters or less').matches(phoneRegExp, 'Only numbers, space, parenthesis, + and - are accepted.').nullable(),
        country: yup.string().max(50, 'Must be 50 characters or less'),
        address: yup.string().max(150, 'Must be 150 characters or less'),
        postalCode: yup.string().max(50, 'Must be 50 characters or less'),
        street: yup.string().max(150, 'Must be 150 characters or less'),
        state: yup.string().max(150, 'Must be 150 characters or less'),
        nationality: yup.string().max(150, 'Must be 150 characters or less'),
        language: yup.string().max(150, 'Must be 150 characters or less'),
        notes: yup.string().max(250, 'Must be 250 characters or less'),
        dob: yup.date().typeError('Must be a value of type date').nullable(),
    };

    const validationSchema = yup.object().shape({

        // Guest validation schema
        guest: yup.object().shape(contactValidationSchema),

        // Booker validation schema
        booker: yup.object().shape(contactValidationSchema),

    });

    const getContactPayload = (data) => {
        const contactPayload = {
            name: data.name ?? "",
            emailId: data.emailId ?? "",
            secondaryEmailId: data.secondaryEmailId ?? "",
            phoneNo: data?.phoneNo.split(" ")?.length !== 1 ? data.phoneNo : "",
            secondaryPhoneNo: data?.secondaryPhoneNo.split(" ")?.length !== 1 ? data.secondaryPhoneNo : "",
            postalCode: data.postalCode ?? "",
            address: data.address ?? "",
            street: data.street ?? "",
            state: data.state ?? "",
            country: data.country ?? "",
            nationality: data.nationality ?? "",
            language: data.language ?? "",
            company: data.company ?? "",
            companyAddress: data.companyAddress ?? "",
            notes: data.notes ?? "",
            dob: data.dob ? moment(data.dob).format("YYYY-MM-DD") : "",
        };
        if (data.selectedContact) {
            contactPayload.id = data.id;
        };
        return contactPayload;
    };

    const handleSubmit = async (data) => {

        setChangeGuest(true);
        setChangeBooker(true);
        
        const guestData = {
            isNew: !data.guest.selectedContact,
            payload: getContactPayload(data.guest),
        }

        const bookerData = {
            isNew: !data.booker.selectedContact,
            payload: getContactPayload(data.booker),
        }

        // are the guest and the booker the same person?:
        const areTheSamePerson = data.booker.checkboxGuestMadeReservation || guestData.payload.id === bookerData.payload?.id
        
        if (guestData.isNew) {
            dispatch(addGuests(guestData.payload)).then((res) => {
                setGuestId(res.data.guest.id);
                if (areTheSamePerson) setBookerId(res.data.guest.id);
            });
        } else {
            dispatch(editGuest(guestData.payload)).then((res) => {
                setGuestId(res.data.guest.id);
                if (areTheSamePerson) setBookerId(res.data.guest.id);
            });
        }

        if (bookerData.isNew) {
            dispatch(addGuests(bookerData.payload)).then((res) => setBookerId(res.data.guest.id));
        } else if (!areTheSamePerson) {
            dispatch(editGuest(bookerData.payload)).then((res) => setBookerId(res.data.guest.id));
        }

    };

    useEffect(() => {
        if (guestId && bookerId) {
            const bookingPayload = {
                "id": bookingData.id,
                "guestId": guestId,
                "bookerId": bookerId,
            };
            dispatch(editBookingContacts(bookingPayload));
        };
    }, [guestId, bookerId]);

    return (
        <div>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting }) => {
                    handleSubmit(values);
                    setSubmitting(false);
                }}
                validateOnChange={false}
                validateOnBlur={false}
            >
                {({ values, errors, validateForm, handleChange, setFieldValue, isSubmitting, handleSubmit }) => (
                    <Form onSubmit={handleSubmit} autoComplete="off" className="p-3">
                        <div className='d-flex justify-content-between align-items-center'>
                            <h3 className={styles.header}>Guest Details</h3>
                            <button
                                type="button"
                                onClick={() => {
                                    let isTheSamePerson = null;
                                    if (!changeGuest) {
                                        setFieldValue("guest", initialValues.guest);
                                        isTheSamePerson = (values.booker?.id === initialValues.guest?.id) && (values.booker?.id && initialValues.guest?.id)
                                    }
                                    if (isTheSamePerson) {
                                        setFieldValue("booker.checkboxGuestMadeReservation", true);
                                        setFieldValue("booker.selectedContact", true);
                                        if (!values.booker.checkboxGuestMadeReservation) showWarningAboutContacts();
                                    }
                                    setChangeGuest(value => !value);
                                }}
                                className={`${styles.btnChangeContact} ${!changeGuest && styles.btnCancel || ""}`}
                            >
                                {changeGuest && "Change Guest" || "Cancel"}
                            </button>
                        </div>
                        { !changeGuest && (
                            <div className={`${styles.searchContainer}`}>
                                <Select
                                    type=""
                                    name={"guest.id"}
                                    value={values.guest.selectedContactData}
                                    onChange={(data) => {
                                        if (
                                            (data?.value && values.booker?.id) &&
                                            (data?.value === values.booker?.id)
                                        ) {
                                            setFieldValue("booker.checkboxGuestMadeReservation", true);
                                            setFieldValue("booker.selectedContact", true);
                                            if (!values.booker.checkboxGuestMadeReservation) showWarningAboutContacts();
                                        }
                                        setFieldValue("guest.selectedContactData", data);
                                        setFieldValue("guest.selectedContact", (data?.value ? true : false));
                                        setFieldValue("guest.id", (data?.value ?? ""));
                                    }}
                                    options={guestList.map((row) => ({ label: row.name, value: row.id })).sort(compare)}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder="Search contact…"
                                    className="w-100 w-lg-50"
                                />
                                <div className={`${styles.paragraphBelowSearch} d-flex align-items-center`}>
                                    <hr className={`${styles.hrClass} flex-grow-1`} />
                                    <p className="mx-3">or add guest to contacts</p>
                                    <hr className={`${styles.hrClass} flex-grow-1`} />
                                </div>
                            </div>
                        )}
                        <ContactForm
                            contactType="guest"
                            values={values}
                            errors={errors}
                            setFieldValue={setFieldValue}
                            handleChange={handleChange}
                            validateForm={validateForm}
                        />
                        <hr />
                        <h3 className={styles.header}>Additional Contacts</h3>
                        <Row>
                            <Col>
                                <div className={`d-flex ${styles.form_wrapper} ${styles.checkboxContainer}`} key="checkboxGuestMadeReservation">
                                    <FormBS.Check
                                        type="checkbox"
                                        name="booker.checkboxGuestMadeReservation"
                                        checked={values.booker.checkboxGuestMadeReservation}
                                        onChange={() => {
                                            setFieldValue("booker.checkboxGuestMadeReservation", !values.booker.checkboxGuestMadeReservation);
                                            setFieldValue("booker.selectedContact", true);
                                            if ((values.booker?.id && values.guest?.id) && values.booker.checkboxGuestMadeReservation) {
                                                if (initialValues.booker?.id != values.guest?.id) {
                                                    setFieldValue("booker.selectedContactData", initialValues.booker.selectedContactData);
                                                    setFieldValue("booker.id", initialValues.booker.id);
                                                    setChangeBooker(true);
                                                } else {
                                                    setFieldValue("booker.selectedContactData", {});
                                                    setFieldValue("booker.id", "");
                                                    setChangeBooker(false);
                                                    if (!initialValues.booker.checkboxGuestMadeReservation) showWarningAboutContacts();
                                                }
                                            }
                                        }}
                                        className={styles.checkboxGuestMadeReservation}
                                    />
                                    <div className={`w-100 d-flex ${styles.form_title}`}>
                                        The guest made the reservation.
                                        <InfoOutlinedIcon
                                            fontSize="small"
                                            color="inherit"
                                            data-tip
                                            data-for="checkboxGuestMadeReservation"
                                            className={styles.toolTipIcon}
                                        />
                                        <ReactTooltip place="bottom" type="dark" id="checkboxGuestMadeReservation" effect="solid" className={styles.toolTip}>
                                            <span>
                                                If someone is making a reservation on behalf of another person, uncheck this field to add the booker to your contact list and associate them with the reservation.
                                            </span>
                                        </ReactTooltip>
                                    </div>
                                </div>
                                {!values.booker.checkboxGuestMadeReservation && (
                                    <div>
                                        <hr />
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <h3 className={styles.header}>Booker Details</h3>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    let isTheSamePerson = null;
                                                    if (!changeBooker) {
                                                        setFieldValue("booker", initialValues.booker);
                                                        isTheSamePerson = (values.guest?.id === initialValues.booker?.id) && (values.guest?.id && initialValues.booker?.id)
                                                    }
                                                    if (isTheSamePerson) {
                                                        setFieldValue("booker.checkboxGuestMadeReservation", true);
                                                        setFieldValue("booker.selectedContact", true);
                                                        showWarningAboutContacts();
                                                    }
                                                    setChangeBooker(value => !value);
                                                }}
                                                className={`${styles.btnChangeContact} ${!changeBooker && styles.btnCancel || ""}`}
                                            >
                                                {changeBooker && "Change Booker" || "Cancel"}
                                            </button>
                                        </div>
                                        {!changeBooker && (
                                            <div className={`${styles.searchContainer}`}>
                                                <Select
                                                    type=""
                                                    name={"booker.id"}
                                                    value={values.booker.selectedContactData}
                                                    onChange={(data) => {
                                                        if (
                                                            (values.guest?.id && data?.value) &&
                                                            (values.guest?.id === data?.value)
                                                        ) {
                                                            setFieldValue("booker.checkboxGuestMadeReservation", true);
                                                            setFieldValue("booker.selectedContact", true);
                                                            showWarningAboutContacts();
                                                        }
                                                        setFieldValue("booker.selectedContactData", data);
                                                        setFieldValue("booker.selectedContact", (data?.value ? true : false));
                                                        setFieldValue("booker.id", (data?.value ?? ""));
                                                    }}
                                                    options={guestList.map((row) => ({ label: row.name, value: row.id })).sort(compare)}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    placeholder="Search contact…"
                                                    className="w-100 w-lg-50"
                                                />
                                                <div className={`${styles.paragraphBelowSearch} d-flex align-items-center`}>
                                                    <hr className={`${styles.hrClass} flex-grow-1`} />
                                                    <p className="mx-3">or add booker to contacts</p>
                                                    <hr className={`${styles.hrClass} flex-grow-1`} />
                                                </div>
                                            </div>
                                        )}
                                        <ContactForm
                                            contactType="booker"
                                            values={values}
                                            errors={errors}
                                            setFieldValue={setFieldValue}
                                            handleChange={handleChange}
                                            validateForm={validateForm}
                                        />
                                    </div>
                                )}
                            </Col>
                        </Row>
                        <div className={`mt-4 d-flex justify-content-center`}>
                            <button 
                                type="submit"
                                disabled={isSubmitting}
                                className={styles.btnSaveChanges}
                            >
                                Save Changes
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default GuestDetails;
